var React = require('react');

function Contract (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor"},[React.createElement("path",{"d":"M12 10V6s0-2-2-2H9v3c0 2-2 2-2 2H4v1s0 2 2 2h4s2 0 2-2z","key":0}),React.createElement("path",{"d":"M9 4V3s0-2-2-2H3S1 1 1 3v4s0 2 2 2h1","key":1})]));
}

Contract.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13"};

module.exports = Contract;

Contract.default = Contract;
